import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class OcrDumpsQueryService {
    public CHECK_DOC_PROCESS_DATA: any;
    public CHECK_All_PROCESS_DATA: any;

    constructor(public apollo: Apollo) {
        this.CHECK_DOC_PROCESS_DATA = gql`                                
            query GetReturnSelectedId($Id:Int!) {
             allOcrDumps(orderBy:ORDER_ID_DESC,condition:{orderId:$Id},first:1) {
              edges {
                node {
                  nodeId
                  orderId
                }
              }
            }
        }

   `;
        this.CHECK_All_PROCESS_DATA = gql`                                
            query allData {
                allOcrDumps(orderBy:ORDER_ID_DESC) {
                # edges {
                    nodes {
                    orderId
                    }
                # }
            }
        }`;
    }
    //1.CHECK DOCUMENT IS PROCESSED(
    CHECK_DOC_PROCESS(orderId) {
        return this.apollo.watchQuery({
            query: this.CHECK_DOC_PROCESS_DATA
            ,
            variables:
            {
                Id: Number.parseInt(orderId),
            },
            fetchPolicy: 'network-only'

        })
    }

    //2.CHECK DOCUMENT IS PROCESSED(
    CHECK_ALL_DOC_PROCESS() {
        return this.apollo.watchQuery({
            query: this.CHECK_All_PROCESS_DATA,
            fetchPolicy: 'network-only'

        })
    }
}


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/queryFiles/ocrDumps.ts